export default "__VITE_ASSET__CsqEu6GU__"